import React from 'react'
import logo from '../../assets/images/vleague-logo.svg';
import yangaLogo from '../../assets/images/yanga-vleague-logo.png';
import '../../App.css';
import { appStore } from '../../stores/appStore';
import leaguesData from '../../config.json';

const Header = () => {
    const { operatorId, leagueName} = appStore((state) => ({
        operatorId: state.operatorId,
        leagueName: state.leagueName
    }));
    const logoURL = leagueName && leagueName?.logoURL
    ? require(`../../assets/images/${leagueName?.logoURL}`)
    : logo;
    
  return (
    <header className="border-bottom border-secondary">
      <div className="d-flex justify-content-center p-2">
        <img src={logoURL} className="App-logo" alt="logo" height={'30px'} />
      </div>
    </header>
  );
}
export default Header;